import {
  FormValues,
  formValues,
} from '@/containers/ConfigurePage/components/FormConfig/formData';
import { TransformedAssetCategoryResult } from '@/types/TransformedAssetCategoryResults';
import type { CustomerType } from '@/utils/fetch/fetchProductSubscriptionByRegion';
import { subscriptionCategories } from '@/utils/fetch/fetchProductSubscriptionByRegion';

export const getCurrentSubscriptionType = (
  currentFormValues: Partial<FormValues>,
  product: TransformedAssetCategoryResult
): CustomerType => {
  if (currentFormValues.student === formValues.student.yes) {
    return subscriptionCategories.student;
  }
  if (currentFormValues.heavyUse === formValues.heavyUse.yes) {
    return subscriptionCategories.heavyUse;
  }
  return !!product.rates.heavyUse && !product.rates.normal
    ? subscriptionCategories.heavyUse
    : subscriptionCategories.normal;
};
